import NewPassword from 'modules/auth/components/NewPassword';
import React from 'react';
import { useNavigate } from 'react-router-dom';

function PasswordReset() {
  const navigate = useNavigate()

  function getParameterByName(name: string, url?: string) { // @ts-ignore
    if (!url) url = window?.location?.href || '' // eslint-disable-line
    // @ts-ignore
    name = name.replace(/[\[\]]/g, '\\$&') // eslint-disable-line
    const regex = new RegExp(`[?&#]${name}(=([^&#]*)|&|#|$)`);
    const results = regex.exec(url)
    if (!results) return null
    if (!results[2]) return ''
    return decodeURIComponent(results[2].replace(/\+/g, ' '))
  }
  const redirectUrl = window.location.href.includes('mobile') 
    ? 'beautify://newpassword'
    : `${window.location.origin}/new-password`

  const url = `${process.env.REACT_APP_SUPABASE_URL}/auth/v1/verify?token=${getParameterByName('access_token')}&type=recovery&redirect_to=${redirectUrl}`
  if (getParameterByName('access_token')) {
    // @ts-ignore
    window.location.href = url
  }

  return (
    <NewPassword
      onClose={() => navigate('/')}
    />
  )
}

export default PasswordReset
